import { css } from 'emotion';
import React from 'react';

type Props = {
  poster?: string,
  src: string,
  onPlay: (e: Event) => void,
  onPause: (e: Event) => void,
  onTimeUpdate: (e: Event) => void,
  onSeeked: (e: Event) => void,
  onSeeking: (e: Event) => void,
  onError: (e: Event) => void,
  initialTime: number,
  seekTime: number,
};

type State = {};
export default class Video extends React.Component<Props, State> {
  videoNode?: HTMLVideoElement;

  componentDidMount() {
    this.videoNode?.addEventListener('play', this.props.onPlay);
    this.videoNode?.addEventListener('pause', this.props.onPause);
    this.videoNode?.addEventListener('timeupdate', this.props.onTimeUpdate);
    this.videoNode?.addEventListener('seeked', this.props.onSeeked);
    this.videoNode?.addEventListener('seeking', this.props.onSeeking);
    this.videoNode?.addEventListener('error', this.props.onError);
    this.videoNode?.addEventListener('loadedmetadata', this.setInitialTime);
  }

  componentDidUpdate(prevProps) {
    // let the parent set the current time after it's loaded
    if (this.props.seekTime !== prevProps.seekTime && this.videoNode) {
      this.videoNode.currentTime = this.props.seekTime;
    }
  }

  componentWillUnmount() {
    // make sure it's unloaded
    this.videoNode?.removeEventListener('play', this.props.onPlay);
    this.videoNode?.removeEventListener('pause', this.props.onPause);
    this.videoNode?.removeEventListener('timeupdate', this.props.onTimeUpdate);
    this.videoNode?.removeEventListener('seeked', this.props.onSeeked);
    this.videoNode?.removeEventListener('seeking', this.props.onSeeking);
    this.videoNode?.removeEventListener('error', this.props.onError);
    this.videoNode?.removeEventListener('loadedmetadata', this.setInitialTime);
    this.videoNode?.setAttribute('src', '');
    this.videoNode?.load();
  }

  render() {
    const styles = {
      display: 'inline-block',
      maxWidth: '85%',
      maxHeight: '85%',
      margin: 'auto auto',
      verticalAlign: 'middle',
      borderRadius: 3,
      backgroundColor: '#000',
      boxShadow: '0 14px 45px rgba(0,0,0,0.25), 0 10px 18px rgba(0,0,0,0.22)',
      // @ts-ignore
      '@phone': {
        maxWidth: '100%',
        maxHeight: '100%',
        borderRadius: 0,
        boxShadow: 'none',
      },
    };
    return (
      <video
        key={this.props.src}
        className={css(styles)}
        preload="auto"
        poster={this.props.poster}
        controls
        src={this.props.src}
        ref={this.bindNode}
        playsInline
      />
    );
  }

  bindNode = (node) => {
    this.videoNode = node;
  };

  setInitialTime = () => {
    if (this.videoNode) {
      this.videoNode.currentTime = this.props.initialTime || 0;
    }
  };
}
